import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ScrollReveal } from './ScrollReveal';
interface SectionCTAProps {
  headline: string;
  buttonText?: string;
  className?: string;
  compact?: boolean;
}
export function SectionCTA({
  headline,
  buttonText = 'QUIERO EMPEZAR AHORA',
  className = '',
  compact = false
}: SectionCTAProps) {
  return <ScrollReveal delay={0.2} direction="up" width="100%" className={className} data-id="element-321">
      <div className="relative mt-12 md:mt-16" data-id="element-322">
        {/* Container */}
        <div className="relative rounded-2xl bg-white/[0.03] border border-white/[0.08] overflow-hidden" data-id="element-323">
          {/* Top glow line */}
          <div className="h-px w-full bg-gradient-to-r from-transparent via-cyan-500/50 to-transparent" data-id="element-324" />

          <div className={`${compact ? 'p-6 md:p-8' : 'p-8 md:p-10'} text-center`} data-id="element-325">
            {/* Headline */}
            <h3 className={`${compact ? 'text-xl md:text-2xl' : 'text-2xl md:text-3xl'} font-bold text-white mb-6`} data-id="element-326">
              {headline}
            </h3>

            {/* Price display */}
            <div className="inline-flex items-baseline gap-3 mb-6" data-id="element-327">
              <span className="text-gray-500 line-through text-lg" data-id="element-328">$97</span>
              <span className={`${compact ? 'text-3xl md:text-4xl' : 'text-4xl md:text-5xl'} font-black text-white tracking-tight`} data-id="element-329">
                $16.39
              </span>
              <span className="bg-green-500/20 text-green-400 px-2.5 py-1 rounded-full text-xs font-bold border border-green-500/30 uppercase tracking-wide" data-id="element-330">
                -83% OFF
              </span>
            </div>

            {/* CTA Button */}
            <div className="flex justify-center mb-5" data-id="element-331">
              <CTAButton text={buttonText} size={compact ? 'md' : 'lg'} showIcon={true} data-id="element-332" />
            </div>

            {/* Trust line */}
            <p className="text-sm text-gray-500 flex items-center justify-center gap-2 flex-wrap" data-id="element-333">
              <span data-id="element-334">🔒 Pago Seguro</span>
              <span className="w-1 h-1 bg-gray-600 rounded-full hidden sm:block" data-id="element-335" />
              <span data-id="element-336">⚡ Acceso Inmediato</span>
              <span className="w-1 h-1 bg-gray-600 rounded-full hidden sm:block" data-id="element-337" />
              <span data-id="element-338">7 días de garantía</span>
            </p>
          </div>
        </div>
      </div>
    </ScrollReveal>;
}